/**
 * Fime – Services Overview: mobile accordion
 *
 * Mobile-only accordion for the Offering template's Content Sections.
 * Desktop/tablet uses a separate always-visible layout (see the
 * "hidden md:block" markup) — this module only touches
 * .services-accordion, so it's a no-op on pages without that section.
 *
 * Single-open behavior: opening one item closes any other open item
 * in the same accordion. The first item starts open (already reflected
 * server-side via the "hidden" attribute on its panel).
 */

document.querySelectorAll('.services-accordion').forEach(function (accordion) {
	const headers = accordion.querySelectorAll('.accordion-header');

	headers.forEach(function (header) {
		header.addEventListener('click', function () {
			const panel = header.nextElementSibling;
			const isOpen = header.getAttribute('aria-expanded') === 'true';

			// Close every item in this accordion first.
			headers.forEach(function (otherHeader) {
				otherHeader.setAttribute('aria-expanded', 'false');
				const otherPanel = otherHeader.nextElementSibling;
				if (otherPanel) otherPanel.hidden = true;
			});

			// Re-open the clicked one, unless it was already open (toggle-closed).
			if (!isOpen) {
				header.setAttribute('aria-expanded', 'true');
				panel.hidden = false;
			}
		});
	});
});
